import axios from "axios";

export default axios.create({
  baseURL: "https://api-sistema-gestao-clientes.vercel.app",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});
